import { render } from "./HelloWorld.vue?vue&type=template&id=770155d6&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=770155d6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-770155d6"

export default script